import React, { useState } from 'react';
import { supabase } from './supabase';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isForgotPassword) {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: window.location.origin,
        });
        if (error) throw error;
        alert('Password reset email sent! Check your inbox.');
        setIsForgotPassword(false);
      } else if (isSignUp) {
        const { data, error } = await supabase.auth.signUp({ // eslint-disable-line no-unused-vars
          email,
          password,
          options: {
            emailRedirectTo: window.location.origin
          }
        });
        if (error) throw error;
        
        if (data.user && !data.session) {
          alert('Please check your email and click the confirmation link to complete signup!');
        } else {
          alert('Account created successfully!');
          onLogin();
        }
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ // eslint-disable-line no-unused-vars
          email,
          password,
        });
        if (error) throw error;
        onLogin();
      }
    } catch (error) {
      console.error('Auth error:', error);
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            <span className="text-amber-600">भारत</span> Inventory Pro
          </h1>
          <p className="text-gray-600">Sign in to manage your inventory</p>
        </div>

        <form onSubmit={handleAuth} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              placeholder="Enter your email"
              required
            />
          </div>

          {!isForgotPassword && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="Enter your password"
                required
              />
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-amber-600 text-white py-3 rounded-xl font-semibold hover:bg-amber-700 transition-colors disabled:opacity-50"
          >
            {loading ? 'Loading...' : 
             isForgotPassword ? 'Send Reset Email' :
             isSignUp ? 'Sign Up' : 'Sign In'}
          </button>
        </form>

        <div className="mt-6 text-center space-y-3">
          {!isForgotPassword ? (
            <>
              <button
                onClick={() => setIsSignUp(!isSignUp)}
                className="text-amber-600 hover:text-amber-700 font-medium block w-full"
              >
                {isSignUp ? 'Already have an account? Sign In' : "Don't have an account? Sign Up"}
              </button>
              {!isSignUp && (
                <button
                  onClick={() => setIsForgotPassword(true)}
                  className="text-gray-500 hover:text-gray-700 text-sm"
                >
                  Forgot your password?
                </button>
              )}
            </>
          ) : (
            <button
              onClick={() => {
                setIsForgotPassword(false);
                setIsSignUp(false);
              }}
              className="text-amber-600 hover:text-amber-700 font-medium"
            >
              Back to Sign In
            </button>
          )}
        </div>

        <div className="mt-8 text-center text-sm text-gray-500">
          <p>© 2025 भारत Inventory Pro</p>
          <p className="mt-1">
            Developed by{' '}
            <a 
              href="https://subhojit-paul.pages.dev" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-amber-600 hover:text-amber-700"
            >
              Subhojit
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;